import React from "react";

import { Button, List, Stack, Typography } from "@mui/material";
import { useInfiniteHits } from "react-instantsearch";
import { makeStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

interface Props {
  renderHit: (hit: any) => React.ReactNode;
}

const useStyles = makeStyles()((theme) => ({
  root: {
    borderRadius: 0,
    padding: theme.spacing(4, 3),
  },
  title: {
    fontSize: 18,
    lineHeight: 1,
    fontWeight: 700,
    color: colors.dark,
  },
  closeButton: {
    padding: theme.spacing(1),
    color: colors.gray,
    backgroundColor: "#E8EEF6",
  },
  checkboxLabel: {
    color: colors.gray,
  },
  addButton: {
    padding: theme.spacing(2),
    color: colors.gray,
    backgroundColor: "#E8EEF6",
  },
  helperText: {
    color: colors.gray,
    textAlign: "center",
  },
  list: {
    maxHeight: "calc(100vh - 290px)",
    overflow: "auto",
  },
}));

const SearchHits: React.FC<Props> = ({ renderHit }) => {
  const { classes } = useStyles();
  const { hits, isLastPage, showMore } = useInfiniteHits();

  return (
    <List className={classes.list}>
      {hits.length === 0 && (
        <Stack direction="row" justifyContent="center">
          <Typography className={classes.helperText}>
            No results were found
          </Typography>
        </Stack>
      )}
      {hits.map((hit) => renderHit(hit))}
      {!isLastPage && (
        <Stack direction="row" justifyContent="center">
          <Button variant="outlined" onClick={showMore}>
            Load more
          </Button>
        </Stack>
      )}
    </List>
  );
};

export default SearchHits;
